/**
 * The focus handlers a custom Stripes `Dropdown` trigger must carry (CZNA-1458, CZNA-1465).
 *
 * <p>The menu closes itself on a zero timeout when focus leaves it, and a mouse click on the
 * trigger of an open menu takes focus out of it on mousedown, before the click. Without these
 * handlers that delayed close runs as well as the click's toggle — so the click either reopens
 * what the timeout just closed, or the timeout flips what the click just closed. Popdown's
 * focus handler cancels the pending close once focus lands on the trigger, so the click alone
 * decides.
 */
var dropdownTriggerFocus = function (getTriggerProps) {
    var _a = getTriggerProps({}), onFocus = _a.onFocus, onBlur = _a.onBlur;
    return { onFocus: onFocus, onBlur: onBlur };
};
export default dropdownTriggerFocus;
